export default [{
  path: '/usuarios-externos',
  component: {
    name: 'usuariosExternosBase',
    template: '<router-view />',
    meta: {
      resource: 'usuexterno',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'usuariosexternos',
    component: () => import('@/app-modulo/comuns/usuario-externo/UsuarioExternoView.vue'),
    meta: {
      resource: 'usuexterno',
      action: 'read',
      navActiveLink: 'usuariosexternos',
      pageTitle: 'Cadastro de Usuários Externos',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuariosexternos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-usuario-externo',
    component: () => import('@/app-modulo/comuns/usuario-externo/shared/components/cadastro/UsuarioExterno.vue'),
    meta: {
      resource: 'usuexterno',
      action: 'create',
      navActiveLink: 'usuariosexternos',
      pageTitle: 'Cadastro de Usuários Externos',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuariosexternos' },
        },
        {
          text: 'Novo',
          to: { name: 'usuario-externo' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-usuario-externo',
    component: () => import('@/app-modulo/comuns/usuario-externo/shared/components/cadastro/UsuarioExterno.vue'),
    meta: {
      resource: 'usuexterno',
      action: 'update',
      navActiveLink: 'usuariosexternos',
      pageTitle: 'Cadastro de Usuários Externos',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuariosexternos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-usuario-externo' },
          active: true,
        },
      ],
    },
  }],
}]
